// ✅ src/context/FacilityContext.js
import React, { createContext, useContext, useMemo } from 'react';
import { useAuth } from './AuthContext';

export const FacilityContext = createContext();

const FacilityProvider = ({ facilityId, children }) => {
  const { roles } = useAuth();

  const facilityRole = useMemo(() => {
    const match = roles.find(r => r.facility === facilityId);
    return match?.role || null;
  }, [roles, facilityId]);

  const isOwnerOrManager = facilityRole === 'Owner' || facilityRole === 'Manager';
  const isOwner = facilityRole === 'Owner';
  const isManager = facilityRole === 'Manager';

  return (
    <FacilityContext.Provider
      value={{
        facilityId,
        facilityRole,
        isOwnerOrManager,
        isOwner,
        isManager
      }}
    >
      {children}
    </FacilityContext.Provider>
  );
};

export const useFacility = () => useContext(FacilityContext);
export default FacilityProvider;
